interface RouteValue {
  path: string
  isProtected?: boolean
  backPath?: string
}

// Routes should not be protected - BE is validating them
// Add trailing slashes
const routes = {
  MULTI_HOME: {
    path: 'multi/',
  },
  MULTI_GET_STARTED: {
    path: 'multi/get-started',
  },
  VERIFY_EMAIL: {
    path: 'multi/verify-email',
  },
  CREATE_PASSKEY: {
    path: 'multi/secure-account/',
  },
  MULTI_VERIFY_PHONE: {
    path: 'multi/verify-phone',
  },
  HOME_ADDRESS: {
    path: 'multi/home-address',
  },
  VERIFY_IDENTITY: {
    path: 'multi/verify-identity',
  },
  DOCUMENT_VERIFICATION: {
    path: 'multi/document-verification',
  },
  DOCUMENT_VERIFICATION_COMPLETE: {
    path: 'multi/document-verification-complete',
  },
  WELCOME: {
    path: 'multi/welcome',
  },
  INVESTMENT_GOALS: {
    path: 'multi/investment-goals',
  },
  MANUAL_REVIEW: {
    path: 'multi/manual-review',
  },
  FUNDING: {
    path: 'multi/fund-account',
  },
  ACCOUNT_TRANSFER_SUCCESS: {
    path: 'multi/fund-account/account-transfer-success',
  },
  EMPLOYMENT: {
    path: 'multi/employment',
  },
  SUITABILITY: {
    path: 'multi/bd-shareholder',
  },
  DISCLOSURES: {
    path: 'multi/disclosures',
  },
  WIRE_TRANSFER: {
    path: 'multi/fund-account/wire-transfer',
  },
  FINANCES: {
    path: 'multi/finances',
  },
  CONFIRM_INFORMATION: {
    path: 'multi/confirm-information',
  },
  ACCOUNT_TRANSFER: {
    path: 'multi/fund-account/account-transfer',
  },
  BANK_TRANSFER: {
    path: 'multi/fund-account/bank-transfer',
  },
  BANK_TRANSFER_SUCCESS: {
    path: 'multi/fund-account/bank-transfer-success',
  },
  RETURN_SIGN_IN: {
    path: 'return/sign-in',
  },
  RETURN_VERIFY_EMAIL: {
    path: 'return/verify-email',
  },
  RETURN_VERIFY_PHONE: {
    path: 'return/verify-phone',
  },
  RETURN_ENTER_PHONE: {
    path: 'return/enter-phone',
  },
  //INTEGRATION:EnrollmentConst
} as const

// Record<string, RouteValue> doesn't suggest Route, so we need to define the following types to have keys suggested by TypeScript
type Routes = typeof routes
type RouteKey = keyof Routes
type Route = Record<RouteKey, RouteValue>
export const ROUTES = routes as Route
